<template>
    <div class="content">
        <div class="login-header">
            <a href="index.html" class="logo">
                <img src="/static/logo_color.png">
            </a>
        </div>
        <div class="login-body">
            <form class="el-form" @submit.prevent="submitForm">
                <input type="hidden" value="1" name="enviar">
                <div class="el-form-item">
                    <div class="el-form-item__content">
                        <div class="el-input">
                            <input type="text" autocomplete="off" placeholder="Usuario" class="el-input__inner" v-model="form.user">
                        </div>
                    </div>
                </div> 
                <div class="el-form-item" v-if="formLogin">
                    <div class="el-form-item__content">
                        <div class="el-input">
                            <input type="password" autocomplete="off" placeholder="Contraseña" class="el-input__inner"  v-model="form.pass">
                        </div>
                    </div>
                </div> 
                <div class="result"></div> 
                <div class="el-form-item">
                    <div class="el-form-item__content">
                        <button type="submit" class="el-button el-button--submit"><span>{{btn}}</span></button>
                        <button type="texty" class="el-button" @click="$router.go(-1)"><span>Atrás</span></button>
                    </div>
                </div>
            </form>
        </div>
        <!-- <div class="login-footer">
            <a v-if="!formLogin" href="#" @click="returnLogin" class="text text__primary text__semibold text__16 text-center p-4 d-block">Volver</a>
			<a v-else href="#" @click="remenberPass" class="text text__primary text__semibold text__16 text-center p-4 d-block">¿Has olvidado la contraseña?</a>
        </div> -->
    </div>
</template>
<script>
    import sha1 from 'sha1';
    import { mapGetters, mapState } from "vuex";
    import { LOGIN, RECOVERY_PASS } from "@/store/actions.type";

    export default {
        name: "Login",
        data() {
            return {
                form : {
                    user: null,
                    pass: null
                },
                formLogin: true,
                btn: "Entrar"
            };
        },
        created() {
            this.checkCurrentLogin();
        },
        updated() {
            this.checkCurrentLogin();
        },
        methods: {
            checkCurrentLogin() {
            if (this.currentUser) {
                this.$router.replace(this.$route.query.redirect || "/login");
            }
            },
            submitForm() {
                this.formLogin ? this.login() : this.recoveryPass();
            },
            recoveryPass() {
            this.$store
                .dispatch(RECOVERY_PASS, { user: this.form.user })
                .then(response => {
                    if(response.data.error == true){
                        this.msgError(response.data.response)
                    }else{
                        this.msgSuccess(response.data.response)
                    }
                })
                .catch(error => this.msgError(error.response) );
            },
            login() {
                this.$store
                    .dispatch(LOGIN, { user: this.form.user, pass: sha1(this.form.pass)  })
                    .then(response => this.loginSuccessful(response))
                    .catch(error => this.loginFailed(error));
            },

            loginSuccessful(response) {
                if (!response.token) {
                    this.loginFailed(response);
                    return;
                }
                this.$notify({
                    title: 'Success',
                    message: 'Login correcto',
                    type: 'success',
                    position: 'bottom-right'                    
                });
                this.error = false;
                localStorage.analiticatoken = response.token;

                this.$router.replace(this.$route.query.redirect || { name: "proyectos" })
            },
            loginFailed(request) {
                this.$notify.error({
                    title: 'Error',
                    message: 'Usuario o contraseña incorrecta',
                    position: 'bottom-right'
                });
                this.$store.dispatch("logout");
                delete localStorage.analiticatoken;
            },
            remenberPass() {
                this.btn = "Recuperar contraseña";
                this.formLogin = false;
            },
            returnLogin() {
                this.formLogin = !this.formLogin;
                this.btn = 'Entrar'
            },
            msgSuccess(text){
                this.$notify({
                    title: 'Success',
                    message: text,
                    type: 'success',
                    position: 'top-right'                    
                });
            },
            msgError(text){
                this.$notify.error({
                    title: 'Error',
                    message: text,
                    position: 'top-right'
                });
            }
        },
        computed: {
            ...mapGetters({ currentUser: "currentUser" }),
            ...mapState({errors: state => state.auth.errors})
        }
    };
</script>

<style lang="scss">
    @import url('https://fonts.googleapis.com/css?family=Source+Sans+Pro');
    .login {
        font-family: 'Source Sans Pro', sans-serif;
        -webkit-font-smoothing: antialiased;
        background: #fff;
        font-size: 14px;
        line-height: 1.42857143;
        color: #333;

        background: #9795bb;
        background-image: -webkit-radial-gradient(circle farthest-side at right bottom, #9795bb, #59688d 80%, #426686);
        background-image: -moz-radial-gradient(circle farthest-side at right bottom, #9795bb, #59688d 80%, #426686);
        background-image: -o-radial-gradient(circle farthest-side at right bottom, #9795bb, #59688d 80%, #426686);
        background-image: -ms-radial-gradient(circle farthest-side at right bottom, #9795bb, #59688d 80%, #426686);
        background-image: radial-gradient(circle farthest-side at right bottom, #9795bb, #59688d 80%, #426686);

    }
    .logo {
        margin-top: 0px;
        text-align: center;
        display: block;
        text-decoration: none;
    }
    .logo .brankic-pen {
        color: #FFFFD8;
        font-size: 40px;
    }
    @media (max-width: 767px) {
        .logo .brankic-pen {
            font-size: 34px;
        }
    }
    h3 {
        font-size: 26px;
        color: #fff;
        text-align: center;
        margin-top: 35px;
    }
    @media (max-width: 767px) {
        h3 {
            font-size: 20px;
            margin-top: 15px;
        }
    }

    @media (max-width: 767px) {
        .content {
            max-width: 90%;
            padding: 35px;
        }
    }
    .image-bg {
        background-image: '';
        background-size: cover;
        background-position: center center;
        background-repeat: no-repeat;
        height: 100vh;
    }
    @media (max-width: 767px) {
        .logo .brankic-pen {
            font-size: 34px;
        }
    }
    h3 {
        font-size: 24px;
        color: #fff;
        text-align: center;
        margin-top: 35px;
    }
    @media (max-width: 767px) {
        h3 {
            font-size: 20px;
            margin-top: 15px;
        }
    }
    .login-header {
        border-bottom: 1px solid #ebebeb;
        padding: 35px 0 35px;
        background-color: #fbfbfb;
        text-align: center;
    }
    .login-body {
        padding: 40px 85px 9px;
    }
    .login-footer {
        border-top: 1px solid #ebebeb;
        padding: 25px 0;
        font-style: italic;
        background-color: #fbfbfb;
        text-align: center;
    }
    .content {
        max-width: 385px;
        margin: 0 auto;
        margin-top: 120px;
        /*padding: 42px 48px;*/
        background: #fff;
        box-shadow: 0 1px 40px 0 rgba(0, 0, 0, 0.3);
        border-radius: 3px;
    }
    @media (max-width: 767px) {
        .content {
            max-width: 80%;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/Login/Login.vue